import { render, staticRenderFns } from "./Compose.vue?vue&type=template&id=1b0a39c7&scoped=true"
import script from "./Compose.vue?vue&type=script&lang=js"
export * from "./Compose.vue?vue&type=script&lang=js"
import style0 from "./Compose.vue?vue&type=style&index=0&id=1b0a39c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0a39c7",
  null
  
)

export default component.exports